module.exports = function(bootstrap) {
	bootstrap.directive('testrequired', [function () {
		return {
			restrict: 'A',
			link: function(scope, element, attrs) {
				if (attrs.required) {
					if (attrs.id) {
						var labelElement = element.parentsUntil().find('[for='+attrs.id+']');
						if (labelElement) {
							labelElement.append($('<span style="color: red; margin-left: 6px;">*</span>'));
						}
					}
					else {
						var potentialLabelElement;
						while (potentialLabelElement = element.parent()) {
							if (potentialLabelElement && potentialLabelElement[0] && potentialLabelElement[0].nodeName && potentialLabelElement[0].nodeName.toLowerCase && potentialLabelElement[0].nodeName.toLowerCase() === 'label') {
								var labelElement = potentialLabelElement;
								break;
							}
						}
						if (labelElement) {
							window.labelElement = labelElement;
							// labelElement.append($('<span style="color: red; margin-left: 6px;">*</span>'));
							element.before($('<span style="color: red; margin-left: 6px;">*</span>'));
						}
					}
				}
			}
		};
	}]);
};